export enum Routes {
  HOME = '/',
  LOGIN = '/login',
  REGISTER = '/register',
  COUNTER = '/counter',
}
